import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=bbbb735e&scoped=true&"
import script from "./Paging.js?vue&type=script&lang=js&"
export * from "./Paging.js?vue&type=script&lang=js&"
import style0 from "./Paging.sass?vue&type=style&index=0&id=bbbb735e&lang=sass&scoped=true&rel=stylesheet%2Fsass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbb735e",
  null
  
)

export default component.exports